// extracted by mini-css-extract-plugin
module.exports = {"level_0":"TagsSection_level_0__3sykM"};